import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Form, Input, Message } from 'semantic-ui-react'
import { SEARCH_ACTIONS } from '../actions/search'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'

class CategoryEditor extends Component {
    constructor(props) {
        super(props)
        let id = props.id
        let { category } = this.props.match.params

        if (!id) {
            id = category
        }

        // console.log('CategoryEditor params match', this.props.match, id)

        this.state = {
            id,
            name: '',
            discount: 10,
        }
    }

    componentDidMount() {
        let { id } = this.state
        // console.log('CategoryEditor id is', id)

        this.props.toolbarResult([
            {
                name: 'Salva',
                icon: 'save',
                position: 'right',
                action: () => {
                    this.save()
                },
            },
        ])

        if (id) {
            this.state.network.getCategory(id)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Maybe need this if it stores state between different edits (it shouldn't)
        // console.log('CategoryEditor did update', this.props.creating)
        if (this.props.creating !== prevProps.creating) {
            if (!this.props.creating) {
                
                if (this.props.createStatus.success) {
                    // Navigate back, success!
                    this.setState({
                        status: 'success',
                    })
                    this.props.history.goBack()
                } else {
                    this.setState({
                        status: 'error',
                    })
                }
            }
        }

        let { getCategory } = this.props
        if (getCategory && getCategory.fetching !== prevProps.getCategory.fetching && !getCategory.fetching) {
            if (getCategory.status.success) {
                let category = getCategory.data.data
                // console.log('Setting state with category:', category)
                let { id, ...rest } = category
                this.setState(rest)
            }
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return nextProps
    }

    save() {
        // TODO value checking
        let { id, name, discount } = this.state

        if (name === '') {
            this.setState({
                status: 'error',
            })
            return
        }

        this.props.network.createCategory(id, {
            name,
            discount,
        })
    }

    handleInput(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        // console.log('Handling input', name, target, event)

        this.setState({
            [name]: value,
        })
    }

    render() {
        let { creating, name, discount, getCategory } = this.state

        // console.log('CategoryEditor state:', this.state)
        return (
            <View fullw fullh column between style={{ marginTop: 20, paddingLeft: 20, paddingRight: 20 }}>
                <Form
                    loading={creating || getCategory.fetching}
                    success={this.state.status === 'success'}
                    error={this.state.status === 'error'}
                    warning={this.state.status === 'warning'}
                >
                    <Form.Group widths="equal">
                        <Form.Field
                            id="form-input-control-category-name"
                            control={Input}
                            label={<span className="label">Nome categoria</span>}
                            name="name"
                            value={name}
                            onChange={(e) => this.handleInput(e)}
                            placeholder=""
                        />

                        <Form.Field
                            id="form-input-control-category-cost"
                            control={Input}
                            type="number"
                            label={<span className="label">Sconto in percentuale</span>}
                            placeholder="0"
                            step="1"
                            name="discount"
                            value={discount}
                            onChange={(e) => this.handleInput(e)}
                        />
                    </Form.Group>
                    <Form.Field
                        id="form-button-control-save"
                        control={Button}
                        content="Salva"
                        onClick={() => {
                            this.save()
                        }}
                    />
                    <Message success header="Form Completed" content="Macchina inserita con successo!" />
                    <Message error header="Errore" content="Errore del server, riprova piu' tardi." />
                    <Message warning header="Errore inserimento" list={['Ricontrolla i dati inseriti']} />
                </Form>
            </View>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let {
        createCategory: { data: createResult, fetching: creating, status: createStatus },
        getCategory,
    } = state

    return {
        createResult,
        creating,
        getCategory,
        createStatus,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),

        searchRequest: (result) => SEARCH_ACTIONS.request(result, dispatch),
        searchResult: (result) => SEARCH_ACTIONS.result(result, dispatch),
        searchError: (result) => SEARCH_ACTIONS.error(result, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(CategoryEditor)))
